import { Inject, Component } from '@angular/core'

import { IdentityService } from 'main/services/identity.service'
import { AppSidebarService } from 'main/services/appSidebar.service'
import { MediaUpdatesTrackerService } from 'media.updates/services/mediaUpdatesTracker.service'

import { BootstrapData, CloudConnection } from 'elements-sdk'
import { BOOTSTRAP_DATA } from 'api/module'
import { TapeArchiverService } from 'ltfs/services/tapeArchiver.service'
import { TapeRestorerService } from 'ltfs/services/tapeRestorer.service'
import { TapeJobsService } from 'ltfs/services/tapeJobs.service'

@Component({
  selector: 'app-sidebar',
  templateUrl: './appSidebar.component.pug',
  styleUrls: ['./appSidebar.component.scss'],
})
export class AppSidebarComponent {
  cloudConnections: CloudConnection[]

  constructor (
    public identity: IdentityService,
    public tapeArchiver: TapeArchiverService,
    public tapeRestorer: TapeRestorerService,
    public tapeJobs: TapeJobsService,
    public appSidebar: AppSidebarService,
    public mediaUpdatesTracker: MediaUpdatesTrackerService,
    @Inject(BOOTSTRAP_DATA) private bootstrapData: BootstrapData,
  ) {
  }

  ngOnInit () {
    this.cloudConnections = this.bootstrapData.cloudConnections
  }
}
